<ion-card>
    <ion-card-content>

        <ion-fab vertical="center" horizontal="end" *ngIf="document.documentNumber === 0">
            <ion-row class="ion-no-margin ion-no-padding">
                <ion-col class="ion-no-margin ion-no-padding" *ngIf="document.documentType !== docTypes.CUSTOMERREPAIR" >
                    <ion-fab-button (tap)="addEquipmentModal(1)" size="small" color="light">
                        <ion-icon name="hammer"></ion-icon>
                    </ion-fab-button>
                </ion-col>
                <ion-col class="ion-no-margin ion-no-padding">
                    <ion-fab-button (tap)="addEquipmentModal(2)" size="small" color="light">
                        <ion-icon name="cart"></ion-icon>
                    </ion-fab-button>
                </ion-col>
            </ion-row>
        </ion-fab>
        <ion-label *ngIf="document.documentType !== docTypes.CUSTOMERREPAIR" >Plant Item / Customer Item</ion-label>
        <ion-label *ngIf="document.documentType === docTypes.CUSTOMERREPAIR" >Customer Item</ion-label>

    </ion-card-content>
    <ion-card-content
            *ngIf="document.serviceJob.servicedItem && (document.serviceJob.servicedItem.pdesc || document.serviceJob.servicedItem.plu)"
            class="content">
        <ion-list>
            <ion-item>
                <ion-label>
                    <p *ngIf="document.serviceJob.servicedItem.pdesc">{{document.serviceJob.servicedItem.pdesc}}
                        | {{document.serviceJob.servicedItem.reg}} </p>
                    <p *ngIf="document.serviceJob.servicedItem.plu">{{document.serviceJob.servicedItem.plu}}
                        | {{document.serviceJob.servicedItem.description}} </p>
                </ion-label>
            </ion-item>
            <ion-item *ngIf="document.serviceJob.servicedItem.plu">
                <ion-input type="text" [(ngModel)]="document.serviceJob.servicedItem.serial"
                           placeholder="Serial"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label>Chargeable?</ion-label>
                <ion-checkbox [(ngModel)]="document.serviceJob.isChargeable"></ion-checkbox>
            </ion-item>
        </ion-list>
        <ion-button color="light" expand="full" *ngIf="document.serviceJob.servicedItem.pdesc"
                    (click)="fetchLegacyJobs(document.serviceJob.servicedItem.plantOrProductId)"
                    shape="round">
            View Plant History
        </ion-button>
    </ion-card-content>
</ion-card>
